import React, { useEffect } from 'react';
import classnames from 'classnames';
import T from 'prop-types';
import Collapsible from 'arts/components/Collapsible';
import * as Classes from './styles.module.scss';

const Expandable = ({
  title, children, eKey, open, expand, className, stopOpen
}) => {
  const toggle = (e) => {
    e.preventDefault();
    expand(eKey);
  };

  useEffect(() => {
    if (stopOpen) {
      expand(eKey);
    }
  }, []);

  return (
    <div className={ classnames(Classes.expandable, className) }>
      <a href="#expand" onClick={ toggle }>
        <span className={ `${ Classes.triangle } ${ open ? Classes.open : '' }` } />
        <span>{ title }</span>
      </a>
      <Collapsible collapsed={ !open }>
        <div className={ Classes.content }>
          { children }
        </div>
      </Collapsible>
    </div>
  );
};

Expandable.propTypes = {
  title: T.string.isRequired,
  children: T.node.isRequired,
  eKey: T.string.isRequired,
  open: T.bool.isRequired,
  expand: T.func.isRequired,
  className: T.string,
  stopOpen: T.bool
};

export default Expandable;
